import React, { Component } from 'react';
import {
  BrowserView,
  MobileView
} from "react-device-detect";
import Fade from 'react-reveal/Fade';

import videoMP4 from '../assets/bg.mp4';
import videoWEBm from '../assets/bg.webm';
import bg from '../assets/bg.gif';




class Home extends Component {

  state = {
    loading: true
  };

  componentDidMount() {
    setTimeout(() => this.setState({ loading: false }), 500); 
    document.body.classList.remove('hide');
  }

  render() {

    document.body.classList.add('hide');

    const { loading } = this.state;
    
    if(loading) { 
      return null; 
    }

    return (
    <div>
      <div className="w-full h-screen bg-black text-white flex items-center">
       
        <div className="pl-8 md:pl-16 xl:pl-64 relative z-40">
          <Fade>
            <p className="text-white font-heading font-bold mb-6">Hello, I am Herkko Huttunen</p> 
            </Fade>
          <Fade delay={300}>
            <h1 className="text-white text-5xl md:text-huge-md xl:text-huge md:ml-16">Designer +</h1> 
            </Fade>
          <Fade delay={600}>
            <h1 className="text-white text-5xl md:text-huge-md xl:text-huge md:ml-16">Developer</h1>
          </Fade>
        </div>

       

      </div>
      
      
      <BrowserView>
        <div className="video-container">
          <video autoPlay loop muted>
            <source src={videoMP4} type="video/mp4" />
            <source src={videoWEBm} type="video/webm" />
          </video>
        </div>
      </BrowserView>
      <MobileView>
        <div className="video-container bg-cover bg-center" style={{backgroundImage: "url(" + bg + ")"}}>
        </div>
      </MobileView>

      <Fade bottom delay={300}>
      <div className="absolute pin-l pin-b text-white ml-8 mb-8  md:mb-16 md:ml-16 xl:mb-24 xl:ml-24">
        <a href="mailto:herkko@erhe.fi" rel="noopener noreferrer" className="text-white no-underline"><i className="fas fa-paper-plane mr-2 text-2xl md:text-base"></i> <span className="hidden md:inline">herkko@erhe.fi</span></a>
        <a href="tel:+358503454252" rel="noopener noreferrer" className="text-white no-underline"><i className="fas fa-mobile-alt mr-2 ml-4 text-2xl md:text-base"></i> <span className="hidden md:inline">+358 50 345 4252</span></a>
        <a href="https://github.com/here-erhe/" rel="noopener noreferrer" className="text-white no-underline"><i className="fab fa-github  mr-2 ml-4 text-2xl md:text-base"></i> <span className="hidden md:inline">here-erhe</span></a>
        <a href="https://www.linkedin.com/in/herkko/" rel="noopener noreferrer" className="text-white no-underline"><i className="fab fa-linkedin mr-2 ml-4 text-2xl md:text-base"></i> <span className="hidden md:inline">/herkko</span></a>
        <a href="https://www.instagram.com/here_erhe/" rel="noopener noreferrer" className="text-white no-underline"><i className="fab fa-instagram  mr-2 ml-4 text-2xl md:text-base"></i> <span className="hidden md:inline">/here_erhe</span></a>
        
      </div>
      </Fade>
     
      
    </div>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/pages/Home.js